import { Editor, ReadonlySharedStyleMap, SharedStyle, useValue } from '@tldraw/tldraw'
import { SharedStyleMap } from '../SharedStyleMap'

export function useRelevantStyles(
  editor: Editor,
): { styles: ReadonlySharedStyleMap; opacity: SharedStyle<number> } | null {
  return useValue(
    'getRelevantStyles',
    () => {
      const styles = new SharedStyleMap(editor.getSharedStyles())
      const hasShape = editor.getSelectedShapeIds().length > 0 || !!editor.root.getCurrent()?.shapeType

      if (styles.size === 0 && !hasShape) return null
      return { styles, opacity: editor.getSharedOpacity() }
    },
    [editor],
  )
}
